<template>
    <Divider :orientation="orientation">
        <slot />
    </Divider>
</template>

<script>
import { Divider  } from 'ant-design-vue';
export default {
    components: {
        Divider,
    },
    props: {
        orientation: {
            type: String,
            default: 'left',
        },
    },
};
</script>
